










import FeedbackComponent from '@/components/base/FeedbackComponent'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {ServiceApi} from '@payroll/optimus-common'
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model'
import Component from 'vue-class-component'

@Component({})
export default class SearchMemberComponent extends FeedbackComponent {

  private readonly GET_MEMBERS_TO_IMPERSONATE: string = 'getMembersToImpersonate'

  private searchFields: SearchFieldModel[] = []
  private columns: GridColumn[] = []

  mounted() {
    this.initSearchFields()
    this.initColumns()
  }

  private initSearchFields(): void {

    this.searchFields.push({
      label: 'customerService.popup.memberId',
      property: 'idNumber',
      fieldType: FieldType.TEXT_FIELD
    })
    this.searchFields.push({
      label: 'customerService.popup.memberName',
      property: 'fullName',
      fieldType: FieldType.TEXT_FIELD
    })
  }

  private initColumns(): void {
    this.columns.push({property: 'idNumber', header: 'customerService.popup.memberId'})
    this.columns.push({property: 'fullName', header: 'customerService.popup.memberName'})
    this.columns.push({property: 'phoneNum', header: 'customerService.popup.memberPhoneNumber'})
    this.columns.push({property: 'email', header: 'customerService.popup.memberEmail'})
  }

  private fetchGridData(searchObject: any): void {
    searchObject.pageSize = 10;

    new ServiceApi()
        .setRequestName(this.GET_MEMBERS_TO_IMPERSONATE)
        .setToken(this.accessToken)
        .setRequestBody(searchObject)
        .post(this)
  }

  onRowClick(row: any) {
    this.$emit('onSelectedMember', row);
  }

  onSuccess(data: any, requestName?: string, message?: string): void {
    switch (requestName) {
      case this.GET_MEMBERS_TO_IMPERSONATE:
        this.$emit('successResults', data)
        break
    }
  }
}

